import { CouponRow, PriceRow } from 'server/types';
import { CheckoutSection } from 'server/types/pmts-overrides';
import { PurchaseFn, StripeHandlerFn } from 'shared/payments/types';
import { PageShell } from '../campaign/campaign-page-shell';
import { SectionRenderer } from '../campaign/section-renderer';

type Props = {
  config: CheckoutSection[];
  course: { id: string; title: string };
  price: PriceRow;
  coupon?: CouponRow;
  collectAddress: boolean;
  handleStripe?: StripeHandlerFn;
  beginPurchase: PurchaseFn;
  onPurchaseComplete(opts?: { newUser?: boolean }): Promise<unknown>;
};

export function CustomCheckoutPage(props: Props) {
  return (
    <PageShell docTitle={[props.course.title, 'Checkout']}>
      <SectionRenderer
        sections={props.config}
        checkoutProps={{
          courseId: props.course.id,
          price: props.price,
          coupon: props.coupon,
          collectAddress: props.collectAddress,
          handleStripe: props.handleStripe,
          beginPurchase: props.beginPurchase,
          onPurchaseComplete: props.onPurchaseComplete,
        }}
      />
    </PageShell>
  );
}
